import { render } from "./header.vue?vue&type=template&id=37c1068e&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=37c1068e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-37c1068e"

export default script